import clsx from 'clsx'
import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import useIntersection from 'components/custom-hooks/useIntersection'
import ResponsiveImage from 'components/images/responsive-image'
import Video from 'components/video'
import env from 'config/env'
import segmentProductImageGalleryViewed from '../carousel-images-segment/carouselImagesSegment'
import ImageCarouselAutoPlayVideo from '../image-carousel/image-carousel-auto-play-video/ImageCarouselAutoPlayVideo'

const CarouselHeroImage = React.memo(
  ({ img, idx, productId, onIntersect, is_italist }) => {
    const heroImgRef = useRef()
    const isIntersecting = useIntersection(heroImgRef, {
      threshold: 0.75,
      once: false,
    })
    const isVideo = Boolean(img.full_video_path)

    useEffect(() => {
      if (isIntersecting) {
        onIntersect(idx)
        segmentProductImageGalleryViewed({
          ref_id: productId,
          ref_type: 'pdp',
          id_product: productId,
          image_type: img.image_type,
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isIntersecting])

    if (isVideo) {
      return (
        <div className="pdp__hero-img" ref={heroImgRef} id={`hero-img-${idx}`}>
          <ImageCarouselAutoPlayVideo
            poster={img.full_path}
            src={img.full_video_path}
            className="pdp__hero-img__video"
          />
        </div>
      )
    }

    if (img.video_path) {
      return (
        <div className="pdp__hero-img" ref={heroImgRef} id={`hero-img-${idx}`}>
          <Video
            src={`${env.MEDIA_CLOUDFRONT_URL}${img.video_path}`}
            ratio={0.75}
            playsInline
            loop
            poster={img.full_cover_image_path}
            posterTablet="70vw"
            posterLaptop="45vw"
            posterDesktop="45vw"
            posterBigDesktop="45vw"
          />
        </div>
      )
    }

    return (
      <div className="pdp__hero-img" ref={heroImgRef} id={`hero-img-${idx}`}>
        <ResponsiveImage
          className={clsx({
            'pdp__hero-img__italist-product': is_italist,
          })}
          imgRatio={1.33}
          src={img.full_path}
          cy={`pdp_product_image__${idx}`}
          alt={`pdp_product_image__${idx}`}
          fetchPriority={idx === 0 ? 'high' : undefined}
        />
      </div>
    )
  },
)

CarouselHeroImage.defaultProps = {
  idx: 0,
  onIntersect: () => null,
  is_italist: false,
}

CarouselHeroImage.propTypes = {
  img: PropTypes.shape({
    path: PropTypes.string,
    full_path: PropTypes.string,
    video_path: PropTypes.string,
    image_type: PropTypes.string,
    full_cover_image_path: PropTypes.string,
    full_video_path: PropTypes.string,
  }).isRequired,
  productId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  idx: PropTypes.number,
  onIntersect: PropTypes.func,
  is_italist: PropTypes.bool,
}

export default CarouselHeroImage
